module.exports = __webpack_public_path__ + "img/product_adv.4b863733.jpg";